/**
 * LE SLOT ACTIF DE CET ONGLET (RFC §11, BBG-208 / E4-T1).
 *
 * ─── Pourquoi sessionStorage, et pas autre chose ────────────────────────────
 *
 * Le modèle est « TAB 1 → Identité A, TAB 2 → Identité B » : la sélection est
 * donc PAR ONGLET. `sessionStorage` est exactement ce périmètre — il survit au
 * rechargement de la page (RT-02) et meurt avec l'onglet, sans jamais se
 * confondre avec celui du voisin. Le stockage persistant PARTAGÉ entre onglets
 * du navigateur est, lui, INTERDIT ici : un changement d'identité dans un
 * onglet ne doit RIEN changer aux autres (c'est le bogue que ce chantier
 * supprime). La porte RT-01 en possède le nom exact — écrit ici, ce nom ferait
 * rougir la suite.
 *
 * ─── UNE SEULE CLÉ ──────────────────────────────────────────────────────────
 *
 * `CLE_ONGLET` est la seule clé que ce paquet pose — critère d'acceptation de
 * E4-T1, re-vérifié par la porte RT-01 (le fichier ne peut pas en citer une
 * seconde sans faire rougir la suite). Elle contient un `slotRef`, et rien
 * d'autre : une valeur NON SECRÈTE, sans pouvoir propre (F2/F3 — elle n'est
 * qu'un index dans un scellé que seul le BFF ouvre ; seule, elle n'ouvre rien).
 *
 * ─── Une valeur aberrante n'est pas un incident ──────────────────────────────
 *
 * `sessionStorage` est modifiable par N'IMPORTE QUEL script de la page — y
 * compris par une XSS. On ne lui fait donc aucune confiance : la lecture
 * valide le FORMAT (22 caractères, comme tout slotRef) et ignore le reste.
 * Refuser net un slotRef déformé préserve le seul vrai garde-fou : l'adéquation
 * avec le scellé côté BFF, qui est hors d'atteinte du script malveillant.
 */
/** La SEULE clé — le nom dit le mécanisme, pas le contenu. */
export const CLE_ONGLET = 'betool.slot-actif';
/**
 * Le format d'un slotRef : 22 caractères URL-safe (16 octets en base64url — côté BFF c'est la même loi).
 * Exportée : le canal (E4-T3) juge la charge des signaux avec la même règle.
 */
export const FORME_SLOT_REF = /^[A-Za-z0-9_-]{22}$/;
/**
 * Lit le slot actif de cet onglet, ou null.
 *
 * Une valeur qui n'a pas la forme d'un slotRef est IGNOREE puis effacée : la
 * laisser serait laisser un déchet dont ni la page ni l'utilisateur ne peuvent
 * se défaire — l'effacer coûte une ligne et referme l'état.
 */
export function lireSlotActif(stockage) {
    const brut = stockage.getItem(CLE_ONGLET);
    if (brut === null)
        return null;
    if (FORME_SLOT_REF.test(brut))
        return brut;
    stockage.removeItem(CLE_ONGLET);
    return null;
}
/** Retient `slotRef` comme actif pour CET onglet — aucun appel au serveur : la sélection est LOCALE. */
export function activerSlot(stockage, slotRef) {
    stockage.setItem(CLE_ONGLET, slotRef);
}
/** Oublie la sélection de cet onglet (retrait du slot, déconnexion, trousseau vidé). */
export function oublierSlot(stockage) {
    stockage.removeItem(CLE_ONGLET);
}
//# sourceMappingURL=onglet.js.map